module.exports = __webpack_public_path__ + "static/media/9DESA11.8ce953a9.jpg";